<nav class="navbar navbar-expand-lg navbar-light bg-primary top-gap" *ngIf="authService.isAuthenticated() && (authService.userSignedIn$ | async)">
  <a class="navbar-brand" routerLink="/">
    <fa-icon [icon]="heartbeat" size="lg"></fa-icon>
     {{authService.healthGroup.name}}
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active" routerLink="agenda">Agenda</a>
      </li>
      <li class="nav-item" *ngIf="(authService.isDoctor() || authService.isAdmin())">
        <a class="nav-link" routerLinkActive="active" routerLink="solicitacao">Solicitações</a>
      </li>
      <li class="nav-item" *ngIf="(authService.isDoctor() || authService.isAdmin())">
        <a class="nav-link" routerLinkActive="active" routerLink="receita">Receitas</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active" routerLink="paciente">Pacientes</a>
      </li>

      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{authService.currentUser.name}}
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
          <span *ngIf="(authService.isDoctor() || authService.isAdmin())">
            <a style="color: #212529;" class="dropdown-item" [ngClass]="{'dropdown-item-checked': authService.useHeaders()}" (click)="updateUseHeaders()">Usar cabeçalhos</a>
          </span>
          <a class="dropdown-item" routerLink="senha">Mudar senha</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" routerLink="login" (click)="signOut()">Sair</a>
        </div>
      </li>
    </ul>
  </div>
</nav>

<nav class="navbar navbar-expand-lg navbar-light bg-secondary justify-content-center top-gap" *ngIf="!authService.isAuthenticated() && authService.existsSessionToken()">
  <h3>Sessão expirada, <a href="" (click)="refreshBrowserPage()">clique aqui</a> para fazer login novamente</h3>
</nav>
